import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
  Tooltip,
  Select,
  MenuItem,
} from "@mui/material";
import { useCodingLanguages } from "../../../context/CodingLanguageContext";
import TimerComponent from "../../../components/TimerComponent";

const Navbar = ({ question }) => {
  const { selectedLanguage, handleChange, setSelectedLanguage } =
    useCodingLanguages();
  const [isTimeUp, setIsTimeUp] = useState(false);
  const [showSubmitModal, setShowSubmitModal] = useState(false);

  useEffect(() => {
      setSelectedLanguage(question?.code_language[0].language);
  }, [question]);

  return (
    <AppBar
      position="static"
      sx={{
        bgcolor: "#f5f5f5",
        backgroundImage: "none",
        borderBottom: "1px solid #e0e0e0",
        zIndex: (theme) => theme.zIndex.drawer + 1,
        color: "#000",
      }}
    >
      <Toolbar variant="dense" sx={{ justifyContent: "space-between" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Typography variant="body2" sx={{ fontWeight: 600, color: "#000" }}>
            Time Left:
          </Typography>
          <Box sx={{ color: "#ff6b6b", fontWeight: "bold", fontSize: "1rem" }}>
            <TimerComponent
              setIsTimeUp={setIsTimeUp}
              showSubmitModal={showSubmitModal}
              handleCloseSubmitModal={() => setShowSubmitModal(false)}
              isTimeUp={isTimeUp}
            />
          </Box>
        </Box>
        <div
        // style={{width:'115px'}}
        >
          <Select
            value={selectedLanguage}
            onChange={handleChange}
            size="small"
            sx={{
              background: "white",
              height: { xs: "24px", sm: "30px" },
              fontSize: { xs: "0.65rem", sm: "0.875rem" },
              // minWidth: { xs: "65px", sm: "auto" },
              width:'100%',
              "& .MuiSelect-select": {
                paddingTop: "1px !important",
                paddingBottom: "1px !important",
                display: "flex",
                alignItems: "center",
              },
            }}
          >
            {question?.code_language?.map((l, i) => (
              <MenuItem key={i} value={l.language}>
                {l.language}
              </MenuItem>
            ))}
          </Select>
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
